import React from 'react'
import { Pressable, View } from 'react-native'
import { RouteWithSceneType, TabLabel } from '@components/Tabs'
import * as Colors from '@themes/Colors'

export function TabBar({
  routes,
  currentIndex,
  handleTabPress,
}: {
  routes: RouteWithSceneType[]
  currentIndex: number
  handleTabPress: (nextIndex: number) => void
}) {
  return (
    <View
      style={{
        height: 50,
        alignItems: 'stretch',
        justifyContent: 'space-around',
        flexDirection: 'row',
        backgroundColor: Colors.white,
        position: 'sticky',
        zIndex: 999,
        borderTopWidth: 1,
        borderTopColor: Colors.borderGray,
      }}
    >
      {routes.map((route, i) => (
        <Pressable
          key={route.key}
          style={{
            flexGrow: 1,
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            borderBottomWidth: 2,
            borderBottomColor:
              currentIndex === i ? Colors.primary : Colors.white,
          }}
          onPress={() => handleTabPress(i)}
        >
          <TabLabel route={route} focused={currentIndex === i} />
        </Pressable>
      ))}
    </View>
  )
}
